module.exports = {
    caseStudyHeader: {
        id: 'fH-nVVmvRh6P3gafBlgnAg',
        event: 'optimize.activate.carousel',
    },
    awards: {
        id: 'zAmGW0CzTPOUJTXPeKdIEA',
        event: 'optimize.activate.awards',
    },
};
